module.exports = __webpack_public_path__ + "img/placeholder-fr.ac63b6a7.jpg";